import { render, staticRenderFns } from "./ReceiptDefault.vue?vue&type=template&id=9b7809b2&scoped=true&"
import script from "./ReceiptDefault.vue?vue&type=script&lang=js&"
export * from "./ReceiptDefault.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptDefault.vue?vue&type=style&index=0&id=9b7809b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7809b2",
  null
  
)

export default component.exports